export class BadgeStyle {
  public static readonly NONE = ''; // no badge style
  public static readonly PRIMARY = 'badge-style-primary'; // lightblue
  public static readonly SECONDARY = 'badge-style-secondary'; // gray
  public static readonly SUCCESS = 'badge-style-success'; // green
  public static readonly DANGER = 'badge-style-danger'; // red
  public static readonly WARNING = 'badge-style-warning'; // orange
  public static readonly LIGHT_GRAY = 'badge-style-light-gray'; // custom for archived state
}
